import type { StatusValue } from '@nuvolo/nuux-core/components/NuvoCard';

const conditionStatusMap: Record<string, StatusValue> = {
  green: 'success',
  amber: 'warning',
  red: 'error',
};

export default conditionStatusMap;
